export default __webpack_public_path__ + "static/media/sazmani.57ebdcd0.png";